
export enum AuthTabsEnum {
    LOGIN,
    SIGN_IN
}
